import * as React from 'react';
import { useState } from 'react';
import { Box, Button, Loader } from '@wix/design-system';
import { saveAs } from 'file-saver';
import { HttpClient } from '@wix/http-client';

export const xsrfCookieKey = 'XSRF-TOKEN';
export const xsrfHeaderKey = 'x-xsrf-token';

export const getXsrfCookie = () => {
  const x = document.cookie.indexOf(xsrfCookieKey);
  const y = document.cookie.indexOf('=', x);
  const z = document.cookie.includes(';', y)
    ? document.cookie.indexOf(';', y)
    : undefined;
  return document.cookie.substring(y + 1, z);
};

const baseURL = window.__CONSENT_POLICY_ENABLED__
  ? window.__URL_PREFIX__
  : window.__BASEURL__;
const httpClient = new HttpClient({ baseURL });

const downloadPdf = (
  pdfUrl: string,
  onDownloadPDF: () => void,
  token: string,
) => {
  return httpClient.post(
    pdfUrl,
    { token, 'x-xsrf-token': getXsrfCookie() },
    {
      headers: {
        'content-type': 'application/json',
        Accept: 'text/html,application/xhtml+xml',
        'sec-fetch-dest': 'empty',
        'sec-fetch-mode': 'cors',
        'sec-fetch-site': 'same-origin',
      },
      responseType: 'blob',
    },
  );
};

export const PdfDownloader = ({
  token,
  text,
  pdfUrl,
  onDownloadPDF,
  onDownloadFail,
}: {
  token: string;
  text: string;
  pdfUrl: string;
  onDownloadPDF: () => void;
  onDownloadFail: (error: unknown) => void;
}) => {
  const [showLoader, setShowLoader] = useState(false);

  return (
    <Button
      theme="whiteblueprimary"
      dataHook="download-pdf-button"
      onClick={() => {
        setShowLoader(true);
        downloadPdf(pdfUrl, onDownloadPDF, token)
          .then((response) => {
            saveAs(response.data, 'PriceQuote.pdf');
            onDownloadPDF();
          })
          .catch(onDownloadFail)
          .then(() => setShowLoader(false));
      }}
    >
      <Box align="center" width="110px">
        {showLoader ? <Loader size="tiny" /> : text}
      </Box>
    </Button>
  );
};
